<template>
  <div>
    <div class="form-group">
      <label for="geoserver-layer-name"> Nombre de la capa</label>
      <input
        id="geoserver-layer-name"
        type="text"
        class="form-control"
        v-model="layerData.name"
      />
      <label for="geoserver-category"> Categoría:</label>
      <select id="geoserver-category" class="form-control" v-model="layerData.id_category">
        <option v-for="category in categories" :key="category.id" :value="category.id">
          {{ category.name }}
        </option>
      </select>

      <label for="geoserver-description">Descripción:</label>
      <textarea
        id="geoserver-description"
        class="form-control"
        rows="4"
        v-model="layerData.description"
      ></textarea>

      <label for="geoserver-url"> URL del Servicio WMS</label>
      <input
        id="geoserver-url"
        type="text"
        class="form-control"
        v-model="layerData.url"
      />

      <label for="geoserver-workspace"> Espacio de trabajo</label>
      <input
        id="geoserver-workspace"
        type="text"
        class="form-control"
        v-model="layerData.workspace"
      />

      <label for="geoserver-datastore"> Almacen de datos</label>
      <input
        id="geoserver-datastore"
        type="text"
        class="form-control"
        v-model="layerData.datastore"
      />
    </div>
    <div class="container-action-left" style="justify-content: start">
      <button class="btn btn-secondary" v-on:click="onClickGoBack()">Volver</button>
      <button class="btn btn-secondary" v-on:click="onClickGoNext()">{{ isEdit ? 'Guardar cambios' : 'Crear capa' }}</button>
    </div>
  </div>
</template>

<script>

import {restLayer} from '@/components/mixin/restLayer.js'
import {formatter} from '@/components/mixin/formatter.js'


export default {
  name: "FormularioGeoserver",
  mixins: [formatter,  restLayer],
  data() {
    return {
      layerData: {
        name: "",
        description: "",
        url: "",
        workspace: "",
        datastore: "",
        id_category: "-1",
      },
    };
  },
  props: {
    categories: {
      type: Array,
      required: false,
      default: () => [],
    },
    layerCreationMode: {
      type: String,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },

  watch: {
    initialData: {
      handler(newVal) {
        if (this.isEdit && newVal) {
          this.populateForm(newVal);
        }
      },
      deep: true,
      immediate: true,
    }
  },

  methods: {
    populateForm(data) {
      this.layerData = {
        name: data.name || "",
        description: data.desc || "",
        url: data.provider.url || "",
        workspace: data.provider.geoserverdata.workspace || "",
        datastore: data.provider.geoserverdata.datastore || "",
        id_category: data.id_category || "-1",
      };
    },
    onClickGoBack: function () {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/capas/");
    },
    onClickGoNext: function () {
      this.layer.provider.name= this.layerCreationMode; // geoserver o arcgis
      this.layer.provider.geoserverdata.workspace = this.layerData.workspace;
      this.layer.provider.geoserverdata.datastore = this.layerData.datastore;
      this.layer.desc = this.layerData.description;
      this.layer.id_category = this.layerData.id_category;
      this.layer.name = this.layerData.name;
      this.layer.provider.url = this.layerData.url;
      
      console.log("Se procesa layer de geoserver:", this.layer);
      
      if (this.isEdit) {
        console.log("Se edita layer:", this.layer);
         this.putLayer();
      } else {
         console.log("Se crea layer:", this.layer);
         this.postLayer();
      }
    },
    getData() {
      return { ...this.layerData };
    },
    resetForm() {
      this.layerData = {
        name: "",
        description: "",
        url: "",
        workspace: "",
        datastore: "",
      };
    },
  },
};
</script>
